export const getUrl = (url: string): string => {
  let sitecoreLanguage = window._THULEDATA.SitecoreLanguage;
  let relativeWithoutLanguage = url.split('domainplaceholder.com')[1];

  return relativeWithoutLanguage
    ? `/${sitecoreLanguage.toLowerCase()}${relativeWithoutLanguage}`
    : `/${sitecoreLanguage.toLowerCase()}`;
};

export const formatPrice = (price: string, currency: string): string => {
  if (price === '0' || !window._THULEDATA.showPrice) {
    return '';
  }

  let numberFormat = new Intl.NumberFormat(window._THULEDATA.SitecoreLanguage, {
    style: 'currency',
    currency: currency,
  });

  return numberFormat.format(parseFloat(price));
};
